import React from 'react';
import cx from 'classnames';

import styles from './styles.module.scss';
import { NudgeItem } from 'src/types/dealInsights';
import { map, size } from 'lodash';
import { useDealNudges } from 'src/query/dealInsights/dealInsights';

interface Props {
  dealId?: string;
}

const emptyImg = '/images/dealInsights/noStatis.svg';

const NoResultsFound = ({ msg, }: { msg: string,}) => (
  <div className={styles.emptyState}>
    <img src={emptyImg} alt="No results" className={styles.emptyStateImg} />
    <p className={styles.emptyStateMsg}>{msg}</p>
  </div>
);

const Placeholder = () => {
  return( <div className={cx(styles.placeholder, styles.nudgesPlaceholder)}>
   <div className={styles.count}>
        <span className={cx(styles.block, )} />
    </div>
    <div className={styles.content}>
      <div className={styles.title}>
         <span className={cx(styles.block,)} />
      </div>
      <div className={styles.desc}>
         <span className={cx(styles.block,)} />
      </div>
    </div>
 </div>
)};

export const Nudges = ({
  dealId,
}: Props) => {
  const { data, isLoading: isLoading, isRefetching: isRefetching } = useDealNudges(dealId); // deal details
  const nudges = data?.nudges ?? [];

  if(size(nudges) === 0) return <></>;
  return (
    <section className={styles.container}>
      <h2 className={styles.title}>Nudges & Actions</h2>
      <div className={cx(styles.content)}>
          {map(nudges, (item: NudgeItem, index, array) => {
            return (
              <>
                <div key={index} className={cx(styles.item)}>
                  <p className={styles.count}>{index + 1}</p>
                  <div className={styles.itemContent}>
                    <div className={styles.innerContent}>
                      <h3 className={styles.title}>{item.header}</h3>
                      <p className={styles.desc}>{item.nudgeAction}</p>
                    </div>
                    {/* <div className={styles.action}>
                      <button
                        type="button"
                        className={styles.actionButton}
                        onClick={() => onActionClick?.(item)}
                      >
                        <i className={actionIcon} />
                        <span>{item.action.label}</span>
                      </button>
                    </div> */}
                  </div>
                </div>
                {size(array) !== (index + 1) && <div className={styles.divider}></div>}
              </>
            );
          })}
      </div>
    </section>
  );
};

export default Nudges;